export function LogoMark({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="logo-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#BF953F" />
          <stop offset="0.5" stopColor="#F3E5AB" />
          <stop offset="1" stopColor="#AA771C" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="#0A0908" stroke="rgba(212,175,55,0.5)" />
      <path d="M32 10 L54 24 H10 Z" fill="url(#logo-gold)" />
      <rect x="10" y="24" width="44" height="3" rx="1.5" fill="#F3E5AB" />
      <path d="M12 27 q5 8 10 0 q5 8 10 0 q5 8 10 0 q5 8 10 0 v2 H12 Z" fill="url(#logo-gold)" />
      <rect x="30.5" y="29" width="3" height="20" rx="1.5" fill="#F3E5AB" />
      <rect x="12" y="49" width="40" height="3.5" rx="1.75" fill="url(#logo-gold)" />
    </svg>
  );
}

export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark className="h-11 w-11 shrink-0" />
      <span className="flex flex-col leading-none">
        <span className="font-accent text-lg font-semibold tracking-[0.18em] text-gold-grad">
          JAISWAL
        </span>
        <span className="mt-1 text-[10px] font-medium uppercase tracking-[0.42em] text-stone-300">
          Tent House
        </span>
      </span>
    </span>
  );
}
